import Vue from "vue";
import Router, { Route, RouterOptions } from "vue-router";
import store from "./store/index";

// Routes
import loginRoutes from "@/routes/login";
import userRoutes from "@/routes/users";
import channelsRoutes from "@/routes/channels";
import channelGroupsRoutes from "@/routes/channelGroups";
import styleRoutes from "@/routes/style";
import userGroupsRoutes from "@/routes/userGroups";
import backgroundsRoutes from "@/routes/backgrounds";
import templatesRoutes from "@/routes/templates";
import stagesRoutes from "@/routes/stages";
import boardsRoutes from "@/routes/solutions";
import contentTemplatesRoutes from "@/routes/contentTemplates";
import editorProfilesRoutes from "@/routes/editorProfiles";
import playersRoutes from "@/routes/players";
import reportsRoutes from "@/routes/reports";
import dashboardRoutes from "@/routes/dashboard";
import contractsRoutes from "@/routes/contracts";
import miscRoutes from "@/routes/misc";
import fontsRoutes from "@/routes/fonts";
import powerPlanRoutes from "@/routes/powerPlans";
import authorizations from "@/routes/authorizations";
import customExtension from "@/routes/customExtension";
import sessionRoutes from "@/solutionTypes/sessions/routes";

Vue.use(Router);
const router = new Router({
    mode: "history",
    routes: [
        ...loginRoutes,
        ...userRoutes,
        ...channelsRoutes,
        ...channelGroupsRoutes,
        ...styleRoutes,
        ...userGroupsRoutes,
        ...backgroundsRoutes,
        ...templatesRoutes,
        ...stagesRoutes,
        ...boardsRoutes,
        ...contentTemplatesRoutes,
        ...editorProfilesRoutes,
        ...playersRoutes,
        ...reportsRoutes,
        ...dashboardRoutes,
        ...miscRoutes,
        ...fontsRoutes,
        ...powerPlanRoutes,
        ...contractsRoutes,
        ...authorizations,
        ...customExtension,
        ...sessionRoutes
    ],
    scrollBehavior() {
        return { x: 0, y: 0 };
    }
} as RouterOptions);

/* Global router guards */
router.beforeEach((to: Route, from: Route, next: any) => {
    const login: string = "login";
    const resetpassword: string = "resetpassword";
    const createnewpassword: string = "createnewpassword";
    const oneTimeLogin: string = "oneTimeLogin";
    const authResponse: string = "authResponse";
    const isloggedIn: Boolean = store.getters["authentication/isLoggedIn"];

    // @ts-ignore
    if (to.name.toLocaleLowerCase() === oneTimeLogin.toLocaleLowerCase() ||
        // @ts-ignore
        to.name.toLocaleLowerCase() === authResponse.toLocaleLowerCase()) {
        next();
    } else if (!isloggedIn && (to.name !== login && to.name !== resetpassword && to.name !== createnewpassword)) {
        next({ name: login });
    } else if (isloggedIn && to.name === login) {
        next(false);
    } else {
        next();
    }
});

export default router;
